// extracted by mini-css-extract-plugin
var _1 = "Section_btnContainer__uBRO-";
var _2 = "Section_cancel__EkQ3N";
var _3 = "Section_editContainer__hnQBs";
var _4 = "Section_header__DxUz+";
var _5 = "Section_headerLeft__q5Qfn";
var _6 = "Section_hiddenContainer__0wmP0";
var _7 = "992px";
var _8 = "768px";
var _9 = "Section_personalForm__Vbfxq";
var _a = "Section_readOnlyContainer__1vdJb";
var _b = "Section_save__eUjCY";
var _c = "\"../shared.module.css\"";
export { _1 as "btnContainer", _2 as "cancel", _3 as "editContainer", _4 as "header", _5 as "headerLeft", _6 as "hiddenContainer", _7 as "lg", _8 as "md", _9 as "personalForm", _a as "readOnlyContainer", _b as "save", _c as "shared" }
